export default __webpack_public_path__ + "static/media/CNo.89-1.14241399.jpg";